import Bowser from "bowser";
import { RemoteParticipantData } from "store/remote-participants/types";
import { RemoteParticipant, RemoteVideoTrack } from "twilio-video";

const browser = Bowser.getParser(window.navigator.userAgent);

export function uuidv4() {
  return (([1e7] as any) + -1e3 + -4e3 + -8e3 + -1e11).replace(
    /[018]/g,
    (c: number) =>
      (
        c ^
        (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
      ).toString(16)
  );
}

export const appRegx =
  /Switcher Studio App [0-9A-Fa-f]{8}[-][0-9A-Fa-f]{4}[-][0-9A-Fa-f]{4}[-][0-9A-Fa-f]{4}[-][0-9A-Fa-f]{12}/;
export const isHostingApp = (p: RemoteParticipant | RemoteParticipantData) =>
  appRegx.test(p.identity);

export const getPublicationTracks = (map: Map<string, any>) =>
  Array.from(map.values())
    .filter((p) => p !== undefined)
    .map((t) => t.track);

export const findTrack = (tracks: RemoteVideoTrack[], regexp: RegExp) => {
  return tracks.find((t) => t?.name && regexp.test(t.name));
};

export const findVideoTracks = (map: Map<string, any>) => {
  const tracks = getPublicationTracks(map);
  const screenShareTrack = findTrack(tracks, /-screen/);
  const cameraTrack = findTrack(tracks, /^((?!-screen).)*$/);

  return {
    screenShareTrack,
    cameraTrack,
  };
};

export const findAudioTrack = (map: Map<string, any>) => {
  const tracks = getPublicationTracks(map);
  return tracks[0];
};

export const getBrowser = () => {
  const currentBrowser = browser.getBrowser();
  return currentBrowser;
};

export const getOS = () => {
  const currentOS = browser.getOS();
  return currentOS;
};

export const isWebView = () => {
  return (
    window.navigator.mediaDevices === undefined ||
    !("getUserMedia" in window.navigator.mediaDevices)
  ); // if not present, iOS webview
};

export const twilioSyncEnabled = (() => process.env.REACT_APP_TWILIOSYNC_ENABLED === "true")();
